export default "__VITE_ASSET__DJFHGkzm__"